export const TRAY_CONFIGS = {
  TRAY_48_6X8: '48_6x8',
  TRAY_54_6X9: '54_6x9',
  TRAY_96_8X12: '96_8x12',
} as const;
